import { render, staticRenderFns } from "./zhengtai.vue?vue&type=template&id=0bd7d7f4&scoped=true&"
import script from "./zhengtai.vue?vue&type=script&lang=js&"
export * from "./zhengtai.vue?vue&type=script&lang=js&"
import style0 from "./zhengtai.vue?vue&type=style&index=0&id=0bd7d7f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd7d7f4",
  null
  
)

export default component.exports